import React from "react";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Button } from "../shared/Button/Button";
import {
  SuccessContainer,
  IconContainer,
  StyledIcon,
  Title,
  Subtitle,
  ButtonContainer,
} from "./SuccessMessage.styles";
import { themePalette } from "../../theme";

interface FinalSuccessMessageProps {
  onPrimaryAction: () => void;
  primaryButtonText?: string;
}

export const FinalSuccessMessage: React.FC<FinalSuccessMessageProps> = ({
  onPrimaryAction,
  primaryButtonText,
}) => {
  const { t } = useTranslation();

  return (
    <SuccessContainer>
      <IconContainer>
        <StyledIcon
          icon={faCircleCheck}
          $iconColor={themePalette.greenSuccess}
        />
      </IconContainer>

      <Title>{t("missingBillingInformation.final.title")}</Title>
      <Subtitle>{t("missingBillingInformation.final.subtitle")}</Subtitle>

      <ButtonContainer>
        <Button
          label={primaryButtonText || t("missingBillingInformation.actions.ok")}
          data-testid="primary-action-button"
          onClick={onPrimaryAction}
          fullWidth
          size="medium"
          backgroundColor="greenDark"
        />
      </ButtonContainer>
    </SuccessContainer>
  );
};
